export default __webpack_public_path__ + "static/media/i4.c6c74d0c.png";